import * as presets from './presets/*.grufpreset';
// This will export all presets in the /presets folder as an array
export const factoryPresets = Object.entries(presets).map(([name, preset]) => ({...preset, _metadata: { ...preset._metadata, name, isFactory: true }}));